import axios from "axios";
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import messages from "../../constants/messages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import useLocalWallet from "../../utils/hooks/index";

const ChangeWalletPopup = ({
  show,
  handleClose,
  handleSubmit,
  fetchWalletChangeHistory,
  wallet,
  userReason,
  icon,
  statusMessage,
}) => {
  const { copyToClipboard } = useLocalWallet();
  const [reason, setReason] = useState("");
  const [newWalletAddress, setNewWalletAddress] = useState("");
  const [errorWallet, setErrorWallet] = useState("");
  const [errorReason, setErrorReason] = useState("");

  const user = useSelector((state) => state.userStore.user);
  const role = user.role;

  useEffect(() => {
    if (role === "user") {
      fetchWalletChangeHistory();
    }
  }, []);

  const onSubmit = () => {
    if (!newWalletAddress) {
      setErrorWallet("Please enter new wallet address");
      return;
    }

    if (!reason) {
      setErrorReason("Please enter reason for changing wallet");
      return;
    }

    handleSubmit(newWalletAddress, reason);
    setReason("");
    setNewWalletAddress("");
    fetchWalletChangeHistory();
    handleClose();
  };

  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Request to Change Wallet Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {wallet ? (
            <>
              <div className="user-reason copy-wallet">
                <p>
                  Your Last Change Request
                  <span>
                    {wallet
                      ? `${wallet.substring(0, 4)}...${wallet.slice(-4)}`
                      : ""}
                  </span>
                  <Tooltip title="Copy Wallet Address" arrow>
                    <FontAwesomeIcon
                      icon={faCopy}
                      className="copy-wallet-icon"
                      onClick={() => copyToClipboard(wallet)}
                    />
                  </Tooltip>
                  {statusMessage} {icon}
                </p>
              </div>
              <div className="user-reason">
                <p>
                  <strong>Reason:</strong> {userReason}
                </p>
              </div>
            </>
          ) : (
            <p>{statusMessage}</p>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="newWalletAddress" className="new-wallet-address">
            New Wallet Address<span>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="newWalletAddress"
            value={newWalletAddress}
            onChange={(e) => {
              setNewWalletAddress(e.target.value);
              setErrorWallet("");
            }}
          />
          {!newWalletAddress && <p className="text-warning">{errorWallet}</p>}
        </div>
        <div className="form-group">
          <label htmlFor="reason" className="new-wallet-address">
            Reason for changing wallet<span>*</span>
          </label>
          <textarea
            type="text"
            className="form-control"
            id="reason"
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
              setErrorReason("");
            }}
          />
          {!reason && <p className="text-warning">{errorReason}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          Submit Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeWalletPopup;
